export type DownloadLetterPrintJobIntent =
  | Readonly<{ kind: "blocked"; label: string; disabledReason: string }>
  | Readonly<{
      kind: "download"
      label: string
      jobId: string
      organizationId: string
      completeDelivery: boolean
    }>

export type DownloadLetterPrintJobRequest = Readonly<{
  jobId: string
  organizationId: string
  completeDelivery: boolean
}>

export type DownloadLetterPrintJobOperationResult = Readonly<{
  filename: string
  deliveryCompleted: boolean
}>

export type DownloadLetterPrintJobOperations = Readonly<{
  downloadPrintJob: (
    request: DownloadLetterPrintJobRequest,
  ) => Promise<DownloadLetterPrintJobOperationResult>
}>

export type DownloadLetterPrintJobResult = Readonly<{
  kind: "downloaded"
  jobId: string
  organizationId: string
  filename: string
  deliveryCompleted: boolean
}>

/** A stale snapshot requires explicit regeneration, without rendering provider details. */
export class LetterPrintSelectionExpiredError extends Error {
  constructor() {
    super(
      "Die Briefauswahl ist nicht mehr aktuell. Bitte Auswahl aktualisieren und PDF neu erstellen.",
    )
  }
}
